import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mb-2" }
const _hoisted_2 = { class: "_flexbtwn _ai-b" }
const _hoisted_3 = { class: "_tc--gray gfu-bt--caption _ttu" }
const _hoisted_4 = {
  class: "_tc--dark gfu-bt--b1 _whs-nw _ml-3",
  "data-qa": "statistic-item-value"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
        ($props.tooltipText)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              text: $props.tooltipText
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, { name: "circle-info" })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("b", null, _toDisplayString($props.value), 1 /* TEXT */)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}